<template>
    <div class = "list-entry">
        <div style ="display: block;">
            <buttonc class="button green"  :label="buttonLabel"  v-on:click="OpenNewItemPopup()" style ="float: right;"/>
        </div>
        <div style="clear:both;"></div>
        <div>
            <ul style="list-style-type:none;">
                <li v-for="(entry, i) in items" :key="i" class="list-item">
                    <buttonc class="icon" type="button" icon="fa-pencil" @click="OpenEditItemPopup(i)"/>
                    <buttonc class="icon" type="button" icon="fa-trash" @click="deleteItem(i)"/>
                    <div class="text-container">
                        <labelc class="text" v-for="(value, j) in translateListElement(entry)" :key="j" :text="value"/>
                    </div>
                </li>
            </ul>
        </div>
        
    </div>
</template>

<script>
    export default {
        name: "list-entry",
        data(){
            return{
                buttonLabel: "+",
                maxItems: 3,
                items: [],
                itemLabelMapping: [{key: "label", label: this.$t('global.ui.entry')}, {key: "value", label: this.$t('workBalance.extraPay.value')}]
                
            }
        },
        props:{
            state: Object,
        },
        watch: {
            state: {
                immediate: true,
                handler(newVal, oldVal){
                    this.state = newVal;
                    this.Init();
                    
                }

            },
            
        },
        created(){
        },
        mounted(){
            
        },
        methods: {
            Init(){
                if(this.state.items){
                    this.items = this.state.items;
                }
                if(this.state.itemLabelMapping){
                    this.itemLabelMapping = this.state.itemLabelMapping;
                }
                if(this.state.maxItems){
                    this.maxItems = this.state.maxItems;
                }
            },
            deleteItem(index){
                this.items.splice(index, 1);
            },
            translateListElement(item){
                let values =[];
                this.itemLabelMapping.forEach(mapping => {
                    if(item[mapping.key]){
                        values.push(mapping.label+": "+ item[mapping.key]);
                    } 
                })
                return values;
            },
            OpenNewItemPopup(){
                let view = this;
                let dataEntries = [];
                
                this.itemLabelMapping.forEach(mapping => {
                    dataEntries.push({label: mapping.label, key: mapping.key, hidden: false, type: 'text', value: ''});
                    
                })

                this.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        selectCallback: function (item) {
                            if(view.items.length < view.maxItems){
                                view.items.push(item);
                            } else {
                                view.$helpers.error(this.$t('global.ui.createdErrorX', [this.$t('global.ui.item')]), view.$t('global.ui.maxEntries'));
                            }
                            
                        },
                    },
                    header: this.$t('global.ui.createX', [this.$t('global.ui.item')]),
                    remainAfterSelect: false, 
                    expanded: true,
                    centered: true
                });
            },
            OpenEditItemPopup(index){
                let view = this;
                let dataEntries = [];
                let item = this.items[index]
                this.itemLabelMapping.forEach(mapping => {
                    dataEntries.push({label: mapping.label, key: mapping.key, hidden: false, type: 'text', value: item[mapping.key]});
                    
                })

                this.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        selectCallback: function (item) {
                            view.items[index] = item;
                            view.items = view.items.slice();
                        },
                    },
                    header: this.$t('global.ui.editX', [this.$t('global.ui.item')]),
                    remainAfterSelect: false, 
                    expanded: true,
                    centered: true
                });
            },
           
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .list-entry{
        position: relative;
        display: block;
        width: 100%;
        z-index: 0;
    }
    
    .list-item{
        display: flex;
        align-items: flex-start;
        margin: 5px 0;
        box-shadow: 0 1px 0 var(--contrast-3);
    }
    
    .list-item .icon{
        margin-top: -1px;
    }
    
    .list-item .text-container{
        margin-left: 5px;
    }
    
    .list-item .text-container .label{
        display: block;
        font-size: 16px;
        font-family: DistrictProBook;
        font-weight: 400;
    }
    
</style>
